var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.5 19L8.5 12L15.5 5","stroke":"currentColor","strokeWidth":"2"}));
}

ArrowLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
